import React from "react";
import { Navigate } from "react-router-dom";
import NotAuthorizedPage from "../pages/NotAuthorizedPage";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  if (!token || !role) return <Navigate to="/login" replace />;
  if (allowedRoles && !allowedRoles.includes(role)) return <NotAuthorizedPage />;

  return children;
};

export default ProtectedRoute;